import React from 'react';
import { routePaths } from 'components/Routes/data';
import { Redirect, Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { PendingApproval } from './PendingApproval';
import { Completed } from './Completed';
import { TabItem } from '@razorpay/blade/components';
import { Box, Heading, TabList, Tabs } from '@razorpay/blade/components';

export const EmployeeBankAccount = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const history = useHistory();

  if (pathname === routePaths.approvalWorkflows.myRequests.employeeBankAccount.root) {
    return (
      <Redirect to={routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals} />
    );
  }

  return (
    <Box padding={["spacing.5", "spacing.8", "spacing.8", "spacing.8"]}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="spacing.3">
        <Heading size="large" as="h1" color="surface.text.gray.normal">
          Bank Account Change Requests
        </Heading>
      </Box>
      <Tabs
        variant="bordered"
        size="medium"
        orientation="horizontal"
        value={history.location.pathname}
        onChange={(value) => {
          history.push(value);
        }}>
        <TabList>
          <TabItem
            value={routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals}>
            Pending Approvals
          </TabItem>
          <TabItem value={routePaths.approvalWorkflows.myRequests.employeeBankAccount.completed}>
            Completed
          </TabItem>
        </TabList>
      </Tabs>
      <Switch>
        <Route
          exact
          path={routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals}>
          <PendingApproval />
        </Route>
        <Route exact path={routePaths.approvalWorkflows.myRequests.employeeBankAccount.completed}>
          <Completed />
        </Route>
      </Switch>
    </Box>
  );
};
